{
  "primer": {
    "eyebrow": "Prayer times and Qibla",
    "headline": "Rhemn needs your location for prayer times and Qibla.",
    "body": "We use it for your prayer times, Qibla direction and local weather — nothing else.",
    "cta": "Continue",
    "skip": "Not now",
    "skip_body": "Prayer times and Qibla will stay off."
  }
}
